YP.UploadPicture = function() {
    var cropSizeW = 168;
    var cropSizeH = 168;

    return {
        init: function() {

            $(".picture").live({
                mouseenter: function () {
                    $(this).find('.add-picture').show();
                },
                mouseleave: function () {
                    $(this).find('.add-picture').hide();
                }
            });

            if($('.add-picture').length > 0) {
              YP.ModalManager().setPreCallSuccess(this.initForm);
            }

            if($('form.create-event').length > 0) {
               YP.ModalManager().setPreCallSuccess(this.initForm);
            }

        },
        updateCoords: function(c) {
            $('.form-picture-upload #picture_coord_x').val(c.x);
            $('.form-picture-upload #picture_coord_y').val(c.y);
            $('.form-picture-upload #picture_width').val(c.w);
            $('.form-picture-upload #picture_height').val(c.h);
        },
        showPreview: function(coords) {
            cropZone = $('.crop-zone img', 'body');
            var imgW = cropZone.width();
            var imgH = cropZone.height();
            var rx = cropSizeW / coords.w;
            var ry = cropSizeH / coords.h;

            $('.form-picture-upload #preview').css({
                width: Math.round(rx * imgW) + 'px',
                height: Math.round(ry * imgH) + 'px',
                marginLeft: '-' + Math.round(rx * coords.x) + 'px',
                marginTop: '-' + Math.round(ry * coords.y) + 'px'
            });
            YP.UploadPicture().updateCoords(coords);
            if (cropSizeW < 168) {
                $('.form-picture-upload .jcrop-handle').hide();
            }
        },
        launchPreview: function(data) {
            cropSizeW = 168;
            cropSizeH = 168;
            $('.refresh', '.form-picture-upload').hide();
            if (!data.error) {
                $('.form-picture-upload .crop-zone').html($('<img class="jcrop" src="/uploads/preview/'+data.name +'"/>').css('width', data.width +'px').css('height', data.height+'px'));
                $('.preview').html($('<img src="/uploads/preview/'+data.name +'" id="preview" class="jcrop"/>'));
                $('.form-picture-upload #picture_name').val(data.name);
                $('.form-picture-upload .preview').parent().show();
                $('.form-picture-upload .actions').show();
                $('.form-picture-upload .miniature-label').show();

                $('.form-picture-upload .crop-zone img').Jcrop({
                    setSelect: [0, 0, cropSizeW, cropSizeH],
                    aspectRatio: 1,
                    onChange: YP.UploadPicture().showPreview,
                    onSelect: YP.UploadPicture().showPreview
                });

            }
            else {
                $('.crop-zone').html('');
                for (var i in data.error) {
                    $('<p/>').css('color','red').attr('class','error').text(data.error[i]).appendTo($('.crop-zone'));
                }
            }
        },
        initZone: function() {
            $('.form-picture-upload .crop-zone').text('');
            $('.form-picture-upload .preview').text('');
            $('.form-picture-upload .crop-zone').text('');
            $('.form-picture-upload .miniature-label').hide();
            $('.form-picture-upload .miniature-label').css('margin-top', '168px');
            $('.form-picture-upload .jcrop-handle').show();
        },
        initForm: function() {
            $('.form-picture-upload #pictureUpload').fileupload({
                dataType: 'json',
                url: $('.form-picture-upload').data('url'),
                add: function(e, data) {
                    data.submit();
                },
                send: function(e, data) {
                    $('.refresh', '.form-picture-upload').show();
                    YP.UploadPicture().initZone();
                },
                done: function(e, data) {
                    if (data.result) {
                        $('.modal-footer').show();
                        YP.UploadPicture().launchPreview(data.result);
                    }
                }
            });
        }
    }
};


window.addEventListener("load", function(){
    YP.UploadPicture().init();
});
